module.exports = __webpack_public_path__ + "static/media/moderator-correct-answer-last-frame.cb0b116a.png";